import { makeAutoObservable, observable } from "mobx";
import { get_symbolStar } from "api/v4/account";
import { get_tokenUserKey } from "api/old/xt-lever";
import { get_privateUserVipInfo } from "api/old/xt-user";

// export interface SymbolStarProps {
//   id: number;
//   symbol: string;
// }

export interface UserInfoProps {
  userAccountLevel?: number; //1=主账户，2=子账户
  fiatCurrencyIds?: number[]; //用户充值过的法币 coinId 数组
}

interface countryInfo{
  code?: number;//{code:971}阿联酋
}
export interface AuthInfoProps {
  country?: countryInfo;
}

export interface UserVipInfoProps {
  makerFeeRate: number;
  takerFeeRate: number;
  vipLevel: number;
  vipName: string;
}

interface StateProps {
  isLogin: boolean;
  token: string;
  userInfo: null | UserInfoProps;
  userVipInfo: WithUndefined<UserVipInfoProps>;
  symbolStar: string[];
  leverWsUserKey: string;
  authInfo: null | AuthInfoProps;
}

const user = makeAutoObservable(
  {
    isLogin: false as StateProps["isLogin"], //用户是否登录
    token: "" as StateProps["token"], //用户token
    userInfo: null as StateProps["userInfo"], //用户信息
    userVipInfo: undefined as StateProps["userVipInfo"], //用户vip费率信息
    symbolStar: [] as StateProps["symbolStar"], //用户自选的市场
    leverWsUserKey: "" as StateProps["leverWsUserKey"], //杠杆ws订阅userKey
    authInfo: null as StateProps["authInfo"], //用户实名认证信息

    get isSubAcc(): boolean {
      return !!(this.userInfo && this.userInfo.userAccountLevel === 2);
    }, //是否是子账户

    updateState(payload: Partial<StateProps>) {
      for (let va in payload) {
        this[va] = payload[va];
      }
    },

    getUserVipInfo() {
      get_privateUserVipInfo().then((data) => (this.userVipInfo = data));
    },
    getSymbolStar() {
      return get_symbolStar().then((ary) => (this.symbolStar = ary));
    },
    getTokenUserKey() {
      get_tokenUserKey().then((data) => (this.leverWsUserKey = data));
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default user;
